import React from "react";
import { IonLabel } from "@ionic/react";

const FormLabel: React.FC = ({ children }) => {
  return (
    <IonLabel
      position="stacked"
      style={{
        color: "#000",
        fontWeight: 600,
        fontSize: "16px",
        overflow: "visible",
      }}
    >
      {children}
    </IonLabel>
  );
};

export default FormLabel;
